import React from 'react';
import './style.scss';

export default function Logo() {
  return <div className='Logo'>
    <u>Links</u>
  </div>;
}
